import { useMemo } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { useTasksByLabel } from '../hooks/useTasksByLabel'
import { useTaskPageSetup } from '@/hooks'
import { useAllLabels } from '@/lib/hooks/useLabels'
import { TaskPageLayout } from '@/routes/features/tasks/components/TaskPageLayout'
import useLoginStore from '@/store/LoginStore'
import useViewModeStore from '@/store/ViewModeStore'

export const Route = createFileRoute(
  '/_AppWrapper/_AppLayout/$workspaceSlug/tags/$tagId',
)({
  component: TagTasksPage,
})

function TagTasksPage() {
  useTaskPageSetup()
  const { tagId } = Route.useParams()
  const workspaceId = useLoginStore((state) => state.workspaceId)
  const { labels } = useAllLabels(workspaceId)
  const label = useMemo(
    () => labels.find((l) => l.id === tagId),
    [labels, tagId],
  )
  const showSubTasks = useViewModeStore((s) => s.showSubTasks)
  const { tasks, isLoading } = useTasksByLabel(tagId, { includeSubTasks: showSubTasks })

  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden">
      <TaskPageLayout
        tasks={tasks}
        isLoading={isLoading}
        showAddTaskInput={false}
        pageTitle={label?.name ?? 'Tag'}
        navigateToSubtasks={true}
      />
    </div>
  )
}

export default TagTasksPage
